export default __webpack_public_path__ + "static/media/biodata-5.4d253c2e.png";